import { useQuery } from '@apollo/react-hooks';
import { get } from 'lodash';
import gql from 'graphql-tag';
import { OrganizationRoles } from '@/constants/organizations';

type OrganizationEdge = {
  node: { id: string; name: string; roles: string[] };
};

const ORGANIZATIONS = gql`
  query ListOrganizationsForSelector($filters: FilterOrganizationsInput) {
    organizations(first: 9999, filters: $filters) {
      edges {
        node {
          id
          name
          roles
        }
      }
    }
  }
`;

export interface OrgFilters {
  roles?: string[];
  isParent?: boolean;

  // Partial type definition - include generic key for compatibility
  [filter: string]: any;
}

export interface OrganizationDataSourceProps {
  filters?: OrgFilters;
  render: (attrs: unknown) => React.ReactElement;
}

const OrganizationDataSource = ({
  filters = {},
  render,
}: OrganizationDataSourceProps) => {
  // roles is not yet supported as a filter by the API
  const { roles: filterRoles, ...apiFilters } = filters;

  const { data, loading } = useQuery(ORGANIZATIONS, {
    variables: { filters: apiFilters },
    fetchPolicy: 'network-only',
  });

  let orgEdges = get(data, 'organizations.edges', []) as OrganizationEdge[];
  if (filterRoles && filterRoles.length > 0) {
    orgEdges = orgEdges.filter(({ node: org }) =>
      org.roles?.some((orgRole) => filterRoles.includes(orgRole)),
    );
  }
  const items = orgEdges.map(({ node: org }) => ({
    label: org.name,
    value: org.id,
  }));

  return render({
    items,
    isLoading: loading,
  });
};

export default OrganizationDataSource;
